import { Button, Flex, HStack, IconButton, Text, useColorModeValue } from '@chakra-ui/react'
import { ArrowRight } from 'lucide-react'
import React from 'react'
import { useLanguage } from '../../hooks/utility/useLanguage'

interface FormFooterProps {
  counterText: string
  isLast: boolean
  canSubmit: boolean
  disabled: boolean
  onSkip: () => void
  onForward: () => void
}

export const FormFooter: React.FC<FormFooterProps> = ({
  counterText,
  isLast,
  canSubmit,
  disabled,
  onSkip,
  onForward,
}) => {
  const { t } = useLanguage()
  const borderColor = useColorModeValue('gray.200', 'gray.700')
  const mutedColor = useColorModeValue('gray.500', 'gray.400')

  return (
    <Flex
      justify='space-between'
      align='center'
      px={5}
      py={3}
      borderTop='1px solid'
      borderColor={borderColor}
    >
      <Text fontSize='sm' color={mutedColor}>
        {counterText}
      </Text>
      <HStack spacing={2}>
        <Button
          variant='outline'
          size='sm'
          isDisabled={disabled}
          onClick={onSkip}
        >
          {t('clarification.skip')}
        </Button>
        <IconButton
          aria-label={isLast ? t('clarification.submit') : t('clarification.nextQuestion')}
          colorScheme='gray'
          size='sm'
          icon={<ArrowRight size={16} />}
          isDisabled={!canSubmit || disabled}
          onClick={onForward}
        />
      </HStack>
    </Flex>
  )
}
